import envConfigDev from "@/../config/env/env.config.client-dev.json";
import envConfigLocal from "@/../config/env/env.config.client-local.json";
import envConfigProd from "@/../config/env/env.config.client-prod.json";

function createConfigs() {
  const type = process.env.NODE_ENV;
  switch (type) {
    case "dev":
      return envConfigDev;
    case "production":
      return envConfigProd;
    case "local":
      return envConfigLocal;
  }
}

export default {
  createConfigs,
};
